import React from "react";
import { Row, Col, Layout } from "antd";
import Header from "../../components/Header";
import FeedNews from "../../components/Feednews/feednews.index";
import Chat from "../../components/chat/chat.index";
import Footer from "../../components/footer/footer.index";
import HeroSection from "../../components/HeroSection/herosection.index";
import GenesysChat from "../../components/livechat/livechat";

import "./home.style.css";

const Home = () => {
  return (
    <Layout className="layout">
      <Header />
      <div className="main-container">
        <Layout className="hero-section">
          <HeroSection />
        </Layout>

        <div className="chat-div">
          <Row
            justify="center"
            // gutter={[{ xs: 8, sm: 8, md: 10, lg: 12, xl: 24, xxl: 24 }, 8]}
          >
            <Col
              className="feednews-container"
              xs={{ span: 24, offset: 0, order: 2 }}
              sm={{ span: 24, order: 2 }}
              md={{ span: 24, order: 2 }}
              lg={{ span: 24, order: 1 }}
              xl={{ span: 12, order: 1 }}
              xxl={{ span: 12, order: 1 }}
            >
              <FeedNews />
            </Col>
            <Col
              className="chat-container"
              xs={{ span: 24, offset: 0, order: 1 }}
              sm={{ span: 24, order: 1 }}
              md={{ span: 24, order: 1 }}
              lg={{ span: 24, order: 2 }}
              xl={{ span: 12, order: 2 }}
              xxl={{ span: 12, order: 2 }}
            >
              <Chat />
            </Col>
          </Row>
        </div>

        <footer className="mainfooter ">
          <Footer />
        </footer>

        {/* <footer className="mainfooter">
            <div className="disclaimer">
              <Row style={{ alignItems:'center'}}>
                <h6 className="disclaimer-title">ข้อกำหนดการใช้งาน Sandee Chatbot</h6>
                <Button type="link" onClick={handleNavigation}>นโยบายความเป็นส่วนตัว</Button>
              </Row>
            </div>
          </footer> */}
      </div>
      <GenesysChat />
    </Layout>
  );
};

export default Home;
